var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLandscape = function SvgIconLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.667,
    height: 12,
    "data-name": "Component 14 \\u2013 1",
    viewBox: "0 0 14.667 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 12H.667A.667.667 0 0 1 0 11.333V.667A.667.667 0 0 1 .667 0H14a.667.667 0 0 1 .667.667v10.667A.667.667 0 0 1 14 12M1.333 10.667h12V1.334h-12Zm2.667-8A1.333 1.333 0 1 0 5.333 4 1.333 1.333 0 0 0 4 2.667m8 6.667v-2L9.333 4.667 6 8 4.667 6.667l-2 2v.667Z",
    "data-name": "Path 79",
    opacity: 0.6
  })));
};
export default SvgIconLandscape;